import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { STAGES } from './sidebar.model';

/**
 * SidebarComponent — left navigation panel for AZ Symphony workflow stages.
 *
 * Displays all nine workflow stages with Material Symbols Outlined icons and labels.
 * Emits stage selection events to the parent AppComponent.
 *
 * Collapse/expand functionality is deferred to a future story.
 */
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.collapsed]': 'collapsed()',
  },
})
export class SidebarComponent {
  /** Controls collapsed visual state. Default: false (expanded). */
  collapsed = input<boolean>(false);

  /** 0-based index of the currently active stage. Default: 0. */
  activeIndex = input<number>(0);

  /** Emits the 0-based index of the clicked stage item. */
  stageSelected = output<number>();

  readonly stages = STAGES;

  onStageSelect(index: number): void {
    this.stageSelected.emit(index);
  }
}
